import { ApplicationState } from '../../store/state';
import { ApplicationAction, ApplicationActions } from '../actions/application.action';

const initialState: ApplicationState = {
  data: null,
  hasError: false,
  errorText: '',
  isLoading: false,
};

export default (state: ApplicationState = initialState, action: ApplicationAction) => {
  switch (action.type) {
    case ApplicationActions.CreateApplicationRequest:
      return {
        ...state,
        data: null,
        hasError: false,
        isLoading: true,
        errorText: '',
      };
    case ApplicationActions.CreateApplicationSuccess:
      return {
        ...state,
        data: action.payload,
        hasError: false,
        isLoading: false,
        errorText: '',
      };
    case ApplicationActions.CreateApplicationError:
      return {
        ...state,
        data: null,
        hasError: true,
        isLoading: false,
        errorText: action.payload,
      };
    default:
      return state;
  }
};